import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["extra", "button"]
  static values = { moreLabel: String, lessLabel: String }

  toggle() {
    const expanded = this.extraTargets[0]?.classList.contains("is-hidden")
    this.extraTargets.forEach((item) => item.classList.toggle("is-hidden", !expanded))
    this.buttonTarget.textContent = expanded ? this.lessLabelValue : this.moreLabelValue
    this.buttonTarget.setAttribute("aria-expanded", expanded.toString())
  }
}
